if (!customElements.get('related-products-carousel')) {
  class RelatedProductsCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.addHoverOnlyCardShadowStyles();
      this.list = this.querySelector('.related-products__slider');
      this.items = Array.from(this.querySelectorAll('.related-products__slide'));
      this.previousButton = this.querySelector('.slider-button--prev');
      this.nextButton = this.querySelector('.slider-button--next');
      this.currentCounter = this.querySelector('.slider-counter--current');
      this.totalCounter = this.querySelector('.slider-counter--total');

      if (!this.list || this.items.length === 0 || !this.previousButton || !this.nextButton) return;

      this.initialized = true;
      this.previousButton.addEventListener('click', () => this.changePage(-1));
      this.nextButton.addEventListener('click', () => this.changePage(1));
      this.list.addEventListener('scroll', () => this.queueUpdate(), { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.list);
      this.update();
    }

    addHoverOnlyCardShadowStyles() {
      if (this.querySelector(':scope > style[data-hover-only-card-shadow]')) return;

      const style = document.createElement('style');
      style.dataset.hoverOnlyCardShadow = '';
      style.textContent = `
        related-products-carousel .card--card::after,
        related-products-carousel .card--standard .card__inner::after {
          box-shadow: none;
          transition: box-shadow var(--duration-default) ease;
        }

        related-products-carousel .card-wrapper:hover .card--card::after,
        related-products-carousel .card-wrapper:focus-within .card--card::after,
        related-products-carousel .card-wrapper:hover .card--standard .card__inner::after,
        related-products-carousel .card-wrapper:focus-within .card--standard .card__inner::after {
          box-shadow:
            var(--shadow-horizontal-offset)
            var(--shadow-vertical-offset)
            var(--shadow-blur-radius)
            rgba(var(--color-shadow), var(--shadow-opacity));
        }
      `;
      this.prepend(style);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    get columnsPerPage() {
      const desktop = Number.parseInt(this.dataset.columnsDesktop, 10) || 4;
      const mobile = Number.parseInt(this.dataset.columnsMobile, 10) || 2;
      return window.matchMedia('(min-width: 990px)').matches ? desktop : mobile;
    }

    get pageCount() {
      return Math.ceil(this.items.length / this.columnsPerPage);
    }

    get itemOffset() {
      if (this.items.length < 2) return this.items[0]?.offsetWidth || 1;
      return this.items[1].offsetLeft - this.items[0].offsetLeft;
    }

    get currentPage() {
      const firstVisibleIndex = Math.round(this.list.scrollLeft / this.itemOffset);
      return Math.min(Math.round(firstVisibleIndex / this.columnsPerPage), this.pageCount - 1);
    }

    changePage(direction) {
      const targetPage = Math.min(Math.max(this.currentPage + direction, 0), this.pageCount - 1);
      const targetIndex = Math.min(targetPage * this.columnsPerPage, this.items.length - 1);
      const targetLeft = this.items[targetIndex].offsetLeft - this.items[0].offsetLeft;

      this.list.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }

    queueUpdate() {
      if (this.updateFrame) return;

      this.updateFrame = requestAnimationFrame(() => {
        this.updateFrame = null;
        this.update();
      });
    }

    update() {
      const currentPage = this.currentPage;
      const pageCount = this.pageCount;

      this.currentCounter.textContent = currentPage + 1;
      this.totalCounter.textContent = pageCount;
      this.previousButton.disabled = currentPage === 0;
      this.nextButton.disabled = currentPage >= pageCount - 1;
    }
  }

  customElements.define('related-products-carousel', RelatedProductsCarousel);
}
